import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import { fetchDashboardStats } from '../../../redux/slices/admin/dashboardSlice';
import { Chart, registerables } from 'chart.js';
import { useNavigate } from 'react-router-dom';

import iconUsers from '../../../images/icon-users.svg';
import iconNutrition from '../../../images/icon-nutrition.svg';
import iconTraining from '../../../images/icon-training.svg';
import iconVideos from '../../../images/icon-videos.svg';
import iconConfiguration from '../../../images/icon-configuration.svg';

Chart.register(...registerables);

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { stats, loading } = useSelector((state) => state.admin_dashboard);

  const referralTrackingChartRef = useRef(null);
  const averageLifetimeChartRef = useRef(null);
  const totalRevenueChartRef = useRef(null);
  const clientsPerCoachChartRef = useRef(null);

  useEffect(() => {
    dispatch(fetchDashboardStats());
  }, [dispatch]); 

  const shouldHideDashboard = (localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && localStorage.getItem("userId") != "1211");
  if (!shouldHideDashboard) {
    navigate('/admin/users');
  }
  
  useEffect(() => {
    if (!loading && stats.clients_per_coach) {
      if (referralTrackingChartRef.current) referralTrackingChartRef.current.destroy();
      if (averageLifetimeChartRef.current) averageLifetimeChartRef.current.destroy();
      if (totalRevenueChartRef.current) totalRevenueChartRef.current.destroy();
      if (clientsPerCoachChartRef.current) clientsPerCoachChartRef.current.destroy();

      referralTrackingChartRef.current = new Chart(document.getElementById('referralTrackingChart'), {
        type: 'bar',
        data: {
          labels: stats?.referral_stats?.labels,
          datasets: [{ label: 'Referrals', data: stats?.referral_stats?.data, backgroundColor: '#FF3D3D' }]
        },
        options: {
          plugins: { legend: { display: true, position: 'top' } },
          scales: { y: { beginAtZero: true } }
        }
      });

      averageLifetimeChartRef.current = new Chart(document.getElementById('averageLifetimeChart'), {
        type: 'bar',
        data: {
          labels: ['1-1 Premium', 'Academy Clients'],
          datasets: [{ label: 'Average Lifetime (months)', data: [stats?.average_lifetime?.premium, stats?.average_lifetime?.academy], backgroundColor: ['#FF3D3D', '#000000'] }]
        },
        options: {
          plugins: { legend: { display: true, position: 'top' } },
          scales: { y: { beginAtZero: true } }
        }
      });

      totalRevenueChartRef.current = new Chart(document.getElementById('totalRevenueChart'), {
        type: 'bar',
        data: {
          labels: ['1-1 Premium', 'Academy Clients'],
          datasets: [{ label: 'Total Revenue', data: [15000, 27000], backgroundColor: ['#FF3D3D', '#000000'] }]
        },
        options: {
          plugins: { legend: { display: true, position: 'top' } },
          scales: { y: { beginAtZero: true } }
        }
      });

      clientsPerCoachChartRef.current = new Chart(document.getElementById('clientsPerCoachChart'), {
        type: 'bar',
        data: {
          labels: stats?.clients_per_coach?.labels,
          datasets: [{ label: 'Clients Per Coach', data: stats?.clients_per_coach?.data, backgroundColor: '#FF3D3D' }]
        },
        options: {
          plugins: { legend: { display: true, position: 'top' } },
          scales: { y: { beginAtZero: true } }
        }
      });
    }
  }, [loading, stats]);

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 g-4 pt-4 main-body-content">
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>1-1 Premium</h3>
              <h1>{stats.one_one_premium_users_count}</h1>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Academy Clients</h3>
              <h1>{stats.ag_users_count}</h1>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Clients Per Coach</h3>
              <canvas id="clientsPerCoachChart" height="261" width="522"></canvas>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Total Revenue</h3>
              <canvas id="totalRevenueChart" height="261" width="522"></canvas>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Average Lifetime</h3>
              <canvas id="averageLifetimeChart" height="261" width="522"></canvas>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Referral Tracking</h3>
              <canvas id="referralTrackingChart" height="261" width="522"></canvas>
            </div>
          </div>

         <div className="col-sm-6 col-xl-4">
            <div className="card-dashboard">
              <h3>Minimal Usage</h3>
              <ol>
                {stats && stats.least_usage_users && stats.least_usage_users.map((user) => (
                  <li key={user.id}>
                    <div>{`${user.first_name} ${user.last_name}`} <span>{user.days}</span></div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        <div className="col-12 m-0"></div>
          <div className="col-6 col-sm-4 col-lg-3 col-xxl">
            <Link className="anchor-dash alex-animation-slide-bottom-small" to="/admin/users">
              <img src={iconUsers} alt="Users" />
              <span>Users</span>
            </Link>
          </div>

          <div className="col-6 col-sm-4 col-lg-3 col-xxl">
            <Link className="anchor-dash alex-animation-slide-bottom-small" to="/admin/nutrition">
              <img src={iconNutrition} alt="Nutrition" />
              <span>Nutrition</span>
            </Link>
          </div>

          <div className="col-6 col-sm-4 col-lg-3 col-xxl">
            <Link className="anchor-dash alex-animation-slide-bottom-small" to="/admin/training">
              <img src={iconTraining} alt="Training" />
              <span>Training</span>
            </Link>
          </div>

          <div className="col-6 col-sm-4 col-lg-3 col-xxl">
            <Link className="anchor-dash alex-animation-slide-bottom-small" to="/admin/videos">
              <img src={iconVideos} alt="Videos" />
              <span>Videos</span>
            </Link>
          </div>

          <div className="col-6 col-sm-4 col-lg-3 col-xxl">
            <Link className="anchor-dash alex-animation-slide-bottom-small" to="/admin/configuration">
              <img src={iconConfiguration} alt="Configuration" />
              <span>Configuration</span>
            </Link>
          </div>

          <div className="col-12 m-10"></div>

        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
